import { joinURL } from 'ufo';
import { useWorkspaceApiBaseUrl } from '#layers/base/public';

export async function deleteMembers(ids: string[]) {
	const endpoint = joinURL(useWorkspaceApiBaseUrl(), 'members');

	return $fetch(endpoint, {
		method: 'DELETE',
		body: JSON.stringify(ids.map((id) => ({ userId: id }))),
	});
}
